import React from 'react';
import { TerminalTransactionCard } from 'src/common/types';

import { TransactionView } from 'src/components';
import { formatCurrencyAmountSimple } from 'src/helpers/formatting';

import { useSelectedTransactions } from 'src/hooks/use-selected-transaction';

export default function AccountTransactionView() {
  const { selectedTransaction } = useSelectedTransactions();

  let cardA: TerminalTransactionCard[] = [];

  if (selectedTransaction) {
    cardA = [
      {
        name: 'Amount',
        value: `R ${formatCurrencyAmountSimple(selectedTransaction.transactionAmount)}`,
      },
      {
        name: 'Transaction description',
        value: `${selectedTransaction.transactionDescription}`,
      },
      {
        name: 'Transaction type',
        value: `${selectedTransaction.transactionTypeDescription}`,
      },
    ];
  }

  let cardB: TerminalTransactionCard[] = [];

  if (selectedTransaction) {
    cardB = [
      {
        name: 'Reference number',
        value: `${selectedTransaction.retrievalReferenceNumber}`,
      },
    ];
  }

  const cards = [cardA, cardB];

  return (
    <>
      <TransactionView
        className="is-hidden-mobile"
        cards={cards}
        mobileTitle="Account Transactions"
        isFullscreen={false}
      />
      <TransactionView
        className="is-hidden-tablet"
        cards={cards}
        mobileTitle="Account Transactions"
        isFullscreen={true}
      />
    </>
  );
}
